import React, { useState, useEffect } from "react";
import { makeStyles, withStyles } from "@material-ui/core/styles";
import {
  Select,
  TextField,
  FormControl,
  FormHelperText,
  MenuItem,
  Grid,
  Switch,
} from "@material-ui/core";
import SelectSpecific from "./select_specific";
import PhoneInputComp from "./phone_component";
import DataService from "../../Service";

const useStyles = makeStyles((theme) => ({
  root: {
    "& > *": {
      margin: theme.spacing(1),
      display: "flex",
    },
  },
  gridRoot: {
    flexGrow: 1,
    // marginBottom: "20px",
    // "& input::placeholder": {
    //   color: '#808080 !important',
    //   opacity: 1
    // }
  },
  helperText: {
    color: "red"
  },
  countryStyle: {
    marginBottom: "23px"
  }
}));

export const Input = (props) => {
  const classes = useStyles();

  const {
    // label,
    type,
    name,
    placeholder,
    required,
    defaultValue,
    disabled,
    readOnly,
    error,
    helperText,
    autoComplete,
    autoFocus,
    classNames,
    rows,
    rowsMax,
    color,
    value,
    multiline,
    index,
    handleChange,
    otherName
  } = props.componentObject;

  return (
    <Grid className={classes.gridRoot}>
      <form>
        <TextField
          classes={classNames}
          id="outlined-basic"
          name={otherName ? otherName : name}
          placeholder={placeholder}
          variant="outlined"
          required={required ? required : false}
          disabled={disabled}
          type={type}
          size="small"
          defaultValue={defaultValue}
          error={helperText ? true : false}
          // helperText={helperText}
          FormHelperTextProps={{
            className: classes.helperText
          }}
          InputLabelProps={{
            shrink: true,
          }}
          InputProps={{
            readOnly: readOnly ? readOnly : false,
          }}
          // autoComplete={autoComplete ? autoComplete : false}
          autoFocus={autoFocus}
          multiline={multiline}
          rows={4}
          //   onChange={() => handleChange()}
          rowsMax={rowsMax}
          color={color}
          fullWidth
          value={value}
          onChange={(e) => handleChange(e.target.value, index)}
          inputProps={{
            autoComplete: 'none',
            form: {
              autocomplete: 'off',
            },
          }}
        /> </form>
      <span style={{ color: "#f44336", fontSize: '0.75rem', marginRight: '14px' }}> {helperText}</span>

    </Grid>
  );
};

export const SimpleSelect = (props) => {
  const classes = useStyles();
  const {
    type,
    selectOptions,
    name,
    placeholder,
    required,
    defaultValue,
    disabled,
    readOnly,
    error,
    helperText,
    autoComplete,
    autoFocus,
    classNames,
    rows,
    rowsMax,
    color,
    value,
    apiVariable,
    params,
    handleChange,
    index,
    label,
    id
  } = props.componentObject;

  // const [selectedValue, setSelectedValue] = useState("");
  const [listOptions, setListoptions] = useState([]);

  // useEffect(() => {
  //   apiVariable &&
  //     DataService.getData(params ? params : "", apiVariable).then((res) => {
  //       setListoptions(res.data.attributes.drop_down_values);
  //     });
  // }, [apiVariable]);

  return (
    <Grid container key={index} style={{ marginBottom: 20 }}>
      <Grid item xs={12}>
        <SelectSpecific
          id={id}
          name={name}
          componentObject={props.componentObject}
        />
      </Grid>
    </Grid>
  );
};

const AntSwitch = withStyles((theme) => ({
  root: {
    width: 28,
    height: 16,
    padding: 0,
    display: "flex",
  },
  switchBase: {
    padding: 2,
    color: theme.palette.grey[500],
    "&$checked": {
      transform: "translateX(12px)",
      color: theme.palette.common.white,
      "& + $track": {
        opacity: 1,
        backgroundColor: theme.palette.primary.main,
        borderColor: theme.palette.primary.main,
      },
    },
  },
  thumb: {
    width: 12,
    height: 12,
    boxShadow: "none",
  },
  track: {
    border: `1px solid ${theme.palette.grey[500]}`,
    borderRadius: 16 / 2,
    opacity: 1,
    backgroundColor: theme.palette.common.white,
  },
  checked: {},
}))(Switch);

export default function AddressComponent(props) {

  return (
    <Grid container>

      <Grid item xs={12} md={4}>
        {props.componentObject.businessAddress.label}
      </Grid>
      <Grid item xs={12} md={7}>
        <Input componentObject={props.componentObject.businessAddress} />
      </Grid>
      <Grid item xs={12} md={4}>
      </Grid>
      <Grid item xs={12} md={7}>
        <Input componentObject={props.componentObject.addressLine1} />
      </Grid>
      <Grid item xs={12} md={4}>
      </Grid>
      <Grid item xs={12} md={7}>
        <Input componentObject={props.componentObject.addressLine2} />
      </Grid>
      <Grid item xs={12} md={4}>
        {/* {props.componentObject.city.label} */}
      </Grid>
      <Grid item xs={12} md={7}>
        <Input componentObject={props.componentObject.city} />
      </Grid>
      <Grid item xs={12} md={4}>
        {/* {props.componentObject.city.label} */}
      </Grid>
      <Grid item xs={12} md={7}>
        <Input componentObject={props.componentObject.county} />
      </Grid>
      <Grid item xs={12} md={4}>
        {/* {props.componentObject.county.label} */}
      </Grid>
      <Grid
        container
        direction="row"
        alignItems="flex-start"
        spacing={1}
      >
        <Grid item xs={4} md={4}>
          {/* <Input componentObject={props.componentObject.zipcode} /> */}
        </Grid>
        <Grid item xs={4} md={3}>
          <Input componentObject={props.componentObject.zipcode} />
        </Grid>

        <Grid item xs={4} md={4}>
          <SimpleSelect componentObject={props.componentObject.country} />
        </Grid>
      </Grid>

      <Grid item xs={12} md={4}>
        {props.componentObject.businessTelephone.label}
      </Grid>
      <Grid item xs={12} md={7}>
        <PhoneInputComp componentObject={{ ...props.componentObject.businessTelephone, label: '' }} />
      </Grid>
      <Grid item xs={12} md={4}>
        {props.componentObject.mobile.label}
      </Grid>
      <Grid item xs={12} md={7}>
        <PhoneInputComp componentObject={{ ...props.componentObject.mobile, label: '' }} />
      </Grid>
    </Grid>
  );
}
